import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import PriceBadge from '@/components/ui/PriceBadge';
import { SEASONAL_PICKS } from '@/data/marketData';

interface SeasonalPicksSectionProps {
  lang: 'en' | 'ta';
}

export default function SeasonalPicksSection({ lang }: SeasonalPicksSectionProps) {
  if (SEASONAL_PICKS.length === 0) return null;

  return (
    <section>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span className="text-xl">🌿</span>
          <h2 className="text-lg font-bold text-foreground">
            {lang === 'en' ? 'Seasonal Picks' : 'பருவகால தேர்வுகள்'}
          </h2>
        </div>
        <span className="section-label text-accent">JUNE 2025</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {SEASONAL_PICKS.map(product => (
          <Link key={`seasonal-${product.id}`} href={`/product-detail?id=${product.id}`} className="block group">
            <div className="card-base card-hover overflow-hidden">
              <div className="relative aspect-video overflow-hidden bg-muted">
                <AppImage
                  src={product.image}
                  alt={product.imageAlt}
                  fill
                  sizes="(max-width: 768px) 100vw, 33vw"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute bottom-3 left-3 right-3">
                  <p className="text-white font-bold text-lg">
                    {lang === 'en' ? product.name : product.nameTa}
                  </p>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="text-xs font-semibold bg-accent text-accent-foreground rounded-full px-2.5 py-1">
                    🌿 Seasonal
                  </span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-muted-foreground mb-2">
                  {lang === 'en' ? product.seasonNote : product.seasonNoteTa}
                </p>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="price-value text-xl">₹{product.currentPrice}</span>
                    <span className="text-xs text-muted-foreground">/{product.unit}</span>
                  </div>
                  <PriceBadge trend={product.trend} change={product.priceChange} changePct={product.priceChangePct} />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}